/******************************************************************************\
 * :$
 *
 * Copyright(c) 2021 SAS Institute Inc., Cary, NC, USA. All Rights Reserved.
 *
 * Name: Login
 *
 * Purpose:
 *
 * Author: craig (Craig.Simpson@sas.com)
 *
 * Support: SAS(r) Solutions OnDemand
 *
 * Input:
 *
 * Output:
 *
 * Parameters: (if applicable)
 *
 * Dependencies/Assumptions:
 *
 * Usage:
 *
 * History:
 * ddmmmyyyy userid description (Change Code)
 * 15Nov2021 craig File created.
 \******************************************************************************/
import React, {useState} from "react";
import {Button, Col, Container, Form, Row} from "react-bootstrap";
import "../Forms.css";
import {IUser} from "../../../../models/user/IUser";
import {setSessionCookie} from "../../../../context/context";
import {Formik, ErrorMessage} from 'formik';
import * as Yup from 'yup';
import {getDataPost} from "../../../../models/data/Data";


//export const Login: React.FC<{ token: string }> = ({token}) => {
export const Login: React.FC = () => {
    //const [sessionUser, setSessionUser] = useState<IUser>(getSessionCookie());
    const [loginMsg, setLoginMsg] = useState<string | undefined>("");

    const schema = Yup.object().shape({
        username: Yup.string().required().email(),
        password: Yup.string().required(),
    });


    const buildForm = () => {
        return (
            <Formik
                validationSchema={schema}
                onSubmit={(values) => {
                    const data = `${encodeURIComponent("username")}=${encodeURIComponent(values.username)}&${encodeURIComponent("password")}=${encodeURIComponent(values.password)}`
                    const loginURL = process.env.REACT_APP_API_URL + "/api/form/login";
                    getDataPost(loginURL, data).then(response => {
                        const user: IUser = response;
                        setSessionCookie(user);
                        //setSessionUser(user);
                        if (user.Authenticated) {
                            window.location.href = "/";
                        } else {
                            setLoginMsg(user.LoginMsg);
                        }
                    })
                }}
                initialValues={{
                    username: '',
                    password: '',
                }}
                validateOnChange={false}
                validateOnBlur={false}>
                {({
                      handleSubmit,
                      handleChange,
                      resetForm,
                      handleBlur,
                      values,
                      touched,
                      isValid,
                      errors,
                      isSubmitting,
                  }) => (
                    <Form className="form-layout" onSubmit={handleSubmit} noValidate={true}>
                        <Row className="mb-3">
                            <Form.Group as={Col} className="col-left" controlId="formBasicEmail">
                                <Form.Label>Email *</Form.Label>
                                <Form.Control required
                                              name={"username"}
                                              className="text-mid-width"
                                              type="email"
                                              placeholder="Enter email"
                                              isValid={touched.username && !errors.username}
                                              onChange={handleChange}/>
                                <Form.Text className="text-muted">Enter your email address.</Form.Text>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid email address
                                </Form.Control.Feedback>
                                <ErrorMessage name={"username"}
                                              render={msg => <div className={"form-error-msg"}>{msg}</div>}/>
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col} className="col-left" controlId="formBasicPassword">
                                <Form.Label>Password *</Form.Label>
                                <Form.Control required
                                              name={"password"}
                                              type="password"
                                              className="text-mid-width"
                                              placeholder="Password"
                                              isValid={touched.password && !errors.password}
                                              onChange={handleChange}/>
                                <Form.Text className="text-muted">Enter the password that accompanies your email
                                    address.</Form.Text>
                                <Form.Control.Feedback type="invalid">
                                    Please enter a password
                                </Form.Control.Feedback>
                                <ErrorMessage name={"password"}
                                              render={msg => <div className={"form-error-msg"}>{msg}</div>}/>
                            </Form.Group>
                        </Row>
                        <Button variant="primary" className="btn-submit" type="submit">
                            Log In
                        </Button>
                    </Form>
                )}
            </Formik>
        )
    }

/*        function getLoginUser() {
            const loginURL = process.env.REACT_APP_API_URL + "/form/login";

            axios.defaults.withCredentials = true;
            return axios.post(loginURL,
                `${encodeURIComponent("user" +
                    "name")}=${encodeURIComponent(username)}&${encodeURIComponent("password")}=${encodeURIComponent(password)}`,
                {
                    //w.Header().Add("Access-Control-Allow-Origin", "http://" + r.Host)
                    withCredentials: true,
                    "headers": {
                        "Content-Type": "submission/x-www-form-urlencoded"
                    }
                })
                .then(response => response.data)
                .catch(err => console.error(err))
        }*/

    return (
        <Container className="form-container" fluid>
            <Row>
                <Col className="page-title">
                    <h1 className="page-title">Log in</h1>
                    <div className={"error-message"}>{loginMsg}</div>
                </Col>
            </Row>
            {buildForm()}
            <Row>
                <Col>
                    <a href={"/forgot"}>Forgot Password</a>
                </Col>
            </Row>
        </Container>
    );

}

/*

export class Login extends React.Component<IFormProps, IFormState> {
    constructor(props: IFormProps) {
        super(props);

        const errors: IErrors = {};
        const values: IValues = {};
        this.state = {
            errors,
            values,
            validated: true
        };
    }



    private handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const target = event.currentTarget;
        const key = target.id as any;
        const value = target.value;
        const {values} = this.state;
        values[key] = value;
    }

    handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        const form = event.currentTarget;

        event.preventDefault();
        event.stopPropagation();
        let validated: boolean = false;
        if (form.checkValidity() === false) {
            validated = false;
        } else {
            validated = true;
            await this.loginUser(
                this.state.values["formBasicEmail"],
                this.state.values["formBasicPassword"]
            );
        }
        this.setState({validated});
        useNavigate("/");
    }




    render(): React.ReactNode {
        return (
            <Container className="form-container" fluid>
                <Row>
                    <Col className="page-title">
                        <h1 className="page-title">Log in</h1>
                    </Col>
                </Row>

                <Form className="form-layout" validated={!this.state.validated} onSubmit={this.handleSubmit}
                      noValidate={true}>
                    <Row className="mb-3">
                        <Form.Group as={Col} className="col-left" controlId="formBasicEmail">
                            <Form.Label>Email *</Form.Label>
                            <Form.Control required className="text-mid-width" type="email" placeholder="Enter email"
                                          onChange={this.handleChange}/>
                            <Form.Text className="text-muted">Enter your email address.</Form.Text>
                            <Form.Control.Feedback type="invalid">
                                Please provide a valid email address
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Row>
                    <Row className="mb-3">
                        <Form.Group as={Col} className="col-left" controlId="formBasicPassword">
                            <Form.Label>Password *</Form.Label>
                            <Form.Control required type="password" className="text-mid-width" placeholder="Password"
                                          onChange={this.handleChange}/>
                            <Form.Text className="text-muted">Enter the password that accompanies your email
                                address.</Form.Text>
                            <Form.Control.Feedback>
                                Please enter a password
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Row>
                    <Button variant="primary" className="btn-submit" type="submit">
                        Log In
                    </Button>
                </Form>

            </Container>
        );
    }

}
*/

